// Module
var code = " <div class=\"node-drop-slot\" (treeDrop)=\"onDrop($event)\" (ghTreeDrop)=\"onDrop($event)\" [treeAllowDrop]=\"allowDrop.bind(this)\"> </div>";
// Exports
module.exports = code;